<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p55"><span><a href="#/Contents#rp55">SPINACH SOUP</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="normal"><span><i>This soup is best eaten as soon as its cooked, as the color will change as it stands.</i></span></p>
<p class="make"><span>10 first-course servings</span></p>
<p class="hang"><span>1 large leek (white part only) thinly sliced</span></p>
<p class="hang"><span>⅓ cup each: sliced carrot, celery</span></p>
<p class="hang"><span>1 tablespoon olive oil</span></p>
<p class="hang"><span>2 quarts Rich Chicken Stock (see <a href="#/Chapter014#p4">p. 4</a>)</span></p>
<p class="hang"><span>2 pounds fresh spinach</span></p>
<p class="hang"><span>Salt and pepper, to taste</span></p>
<p class="hang"><span>½ cup (2 ounces) grated Parmesan cheese</span></p>
<p class="hang"><span>Croutons (see <span href="#/Chapter131#p849" title="Link target outside of Sample">p. 636</span>)</span></p>
<p class="normalt"><span><a id="page_42"></a><b>1.</b> Sauté leek, carrot, and celery in oil in large saucepan until tender, about 8 minutes; add stock and heat to boiling. Add spinach and cook, uncovered, until wilted, about 2 minutes. Process soup in food processor or blender until smooth; season to taste with salt and pepper. Sprinkle each bowl of soup with Parmesan cheese and croutons.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 113</span></p>
<p class="per1"><span>% calories from fat: 31</span></p>
<p class="per1"><span>Protein (g): 9.1</span></p>
<p class="per1"><span>Carbohydrate (g): 9.9</span></p>
<p class="per1"><span>Fat (g): 3.8</span></p>
<p class="per1"><span>Saturated fat (g): 1.2</span></p>
<p class="per1"><span>Cholesterol (mg): 4</span></p>
<p class="per1"><span>Sodium (mg): 229</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 2.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 0.5</span></p>
<p class="per1"><span>Fat: 0.5</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0236.vue?15f2c082